/* eslint-disable @typescript-eslint/naming-convention */
import { type GraphQLResult, generateClient } from 'aws-amplify/api'
import { ConsoleLogger } from 'aws-amplify/utils'
import { enableAuthentication } from '~/components/Utils/Auth'

const logger = new ConsoleLogger('GraphqlClient')

const client = generateClient()

enableAuthentication()

export function amplifyFetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async () => {
    const { data } = await GraphqlClient.query<TData>(query, variables)
    return data
  }
}

export class GraphqlClient {
  static authToken: string | undefined = undefined

  constructor() {
    //
  }

  static set setAuthToken(token: string) {
    logger.debug('setAuthToken', { token })
    GraphqlClient.authToken = token
  }

  static resetToken() {
    GraphqlClient.authToken = undefined
  }

  static async query<T = any>(query: string, variables?: any) {
    logger.verbose('query', { query, variables })

    console.log({ query, variables })

    // console.log(GraphqlClient.authToken)

    // console.log(client)

    return (await client.graphql<T>({
      query,
      variables,
      // authToken: 'aa',
    })) as GraphQLResult<T>
  }
}
